import React from 'react'
import ContactForm from '../../components/landingPage/ContactForm';
import MapComponent from '../../components/landingPage/MapComponent';
import axios from 'axios';
import { API_BASE_URL } from '../../config';


function ContactUsSection() {  

  const handleFormSubmit = (form) => {
    axios.post(`${API_BASE_URL}/email/send-contact-email`, form).then(res => console.log(res)).catch(err => console.log(err));
  }

  return (
    <div className="relative w-full mx-auto" style={{height:"600px"}} id="MapComponent">
      <MapComponent/>
      <ContactForm sendForm={handleFormSubmit}/>
    </div>    
  )
}

export default ContactUsSection
